import React from 'react';
import classNames from 'classnames';

interface BackdropProps {
  onClick: () => void;
  isVisible: boolean;
}

const Backdrop: React.FC<BackdropProps> = ({ onClick, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div
      onClick={onClick}
      className={classNames(
        'fixed inset-0 z-40 bg-black opacity-50 duration-500 animate-in fade-in'
      )}
    />
  );
};

export default Backdrop;
